import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { BBResponseContainer } from '../carrier/response-container';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UnprepairedMaterialService {
  constructor(private http: HttpClient) { }

  getUnprepairedmaterial(searchedDate: string , plateOrTubeDisplayType:string): Observable<BBResponseContainer> {
    let url = environment.BB_SEQUENCING_SERVICE_URL + "reactionset/unprepared";
    
    let requestParam = new HttpParams().set('searchedDate', searchedDate)
    .set('plateOrTubeDisplayType', plateOrTubeDisplayType);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
        error.url = url;
      }));
  }
}
